const OverdraftIcon = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.2'
                d='M5.25 4.5L12.75 12L5.25 19.5V4.5Z'
                fill='#827CA8'
            />
            <path
                d='M5.25 4.5L12.75 12L5.25 19.5V4.5Z'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.75 4.5L20.25 12L12.75 19.5'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default OverdraftIcon;
